import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, switchMap, map } from 'rxjs';
import { getManifest } from './manifestLoader';

export function customHttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new UniversalTranslateLoader(http);
}

export class UniversalTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
  ) {}

  getTranslation(lang: string): Observable<any> {
    const defaultPath = `i18n/${lang}.json`;
    return this.loadSingleTranslation(defaultPath);
  }

  private loadSingleTranslation(path: string): Observable<any> {
    return getManifest(this.http).pipe(
      map(manifest => manifest[path] || `./${path}`),
      switchMap(filePath => this.http.get(filePath)),
    );
  }
}
